const isDST = (date: Date) => {
  const year = date.getFullYear()

  const marchSecondSunday = new Date(year, 2, 1)
  marchSecondSunday.setDate(1 + ((7 - marchSecondSunday.getDay()) % 7) + 7)
  marchSecondSunday.setHours(2, 0, 0, 0) // DST starts at 2:00 AM

  const novemberFirstSunday = new Date(year, 10, 1)
  novemberFirstSunday.setDate(1 + ((7 - novemberFirstSunday.getDay()) % 7))
  novemberFirstSunday.setHours(2, 0, 0, 0) // DST ends at 2:00 AM

  return date >= marchSecondSunday && date < novemberFirstSunday
}

const getEasternTimezone = (globalTime: Date) => {
  const dt = new Date(globalTime)

  dt.setTime(dt.getTime() + dt.getTimezoneOffset() * 60 * 1000)

  const offset = isDST(dt) ? -240 : -300
  dt.setTime(dt.getTime() + offset * 60 * 1000)

  return dt
}

export default getEasternTimezone
